import { REALMS } from "@/constants/process";

export function hasToken(info: { evbasicToken: string | null; evcoreToken: string | null }) {
  return info.evbasicToken || info.evcoreToken;
}

export function getRealmToken(info: {
  evbasicToken: string | null;
  evcoreToken: string | null;
  realm: string | undefined;
}) {
  if (info.realm === REALMS.EVBASIC) {
    return info.evbasicToken;
  }
  if (info.realm === REALMS.EVCORE) {
    return info.evcoreToken;
  }
}
